
import Vue from 'vue'
import Swal from 'sweetalert2'
import { ParsedQuery } from 'query-string'

export default Vue.extend({
  data: () => ({
    dnslink: '',
    filename: ''
  }),

  methods: {
    async open() {
      try {
        if (!this.$ipfs.api) {
          throw new Error('IPFS API undefined!')
        }

        const cidPath = await this.$ipfs.api.dns(this.dnslink) as string
        const cid = cidPath.substring(6)

        const query: ParsedQuery = {
          cid,
          name: this.filename
        }

        this.$router.push({
          path: '/explorer',
          query
        })
      } catch (err) {
        Swal.fire({
          title: 'A problem has occurred',
          text: 'No DNS records linked to an IPFS object found.',
          icon: 'error'
        })
      }
    }
  }
})
